import { ENV } from '../../config/runtimeEnv';

import { GlobalFileResource } from "../../types/file/GlobalFileResourceTypes";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_FILE_SERVER;

export const getGlobalFileResources = async (): Promise<GlobalFileResource[]> => {
    const response = await http.get(`${API_BASE_URL}/global-file-resources`);
    return response.data;
};

export const downloadGlobalFileResource = async (fileId: string, fileName: string): Promise<void> => {
    const response = await http.post(
        `${API_BASE_URL}/global-file-resources/download`,
        { file_id: fileId },
        {
            responseType: "blob",
        }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
